import MapBlock from './mapBlock';

export default class LocationBlockController {
    constructor() {
        this.instances = [];
        this.init();

        this.mapPromise = null; // Used to determine if the Maps api is available
        this.apiKey = null; // Maps API key
    }

    init() {
        if (document.querySelector('section.blMap .mapContainer[data-key]')) {
            this.apiKey = document.querySelector('section.blMap .mapContainer[data-key]').dataset.key;

            this.loadMapsApi().then(() => {
                document.querySelectorAll('section.blMap .mapContainer').forEach(mapContainer => {
                    this.instances.push(new MapBlock(mapContainer));
                });
            });
        }
    }

    loadMapsApi() {
        if (this.mapPromise) {
            return this.mapPromise;
        }

        this.mapPromise = new Promise(resolve => {
            if (window.google && window.google.maps) {
                resolve();
            } else if (this.map) {
                resolve();
            } else {
                // Create public function that gets called when Maps is loaded
                let functionName = `mapsLoaded_${Math.random().toString(12).substring(2, 12) + Math.random().toString(12).substring(2, 6)}`;
                window[functionName] = () => {
                    delete window[functionName];
                    resolve();
                }

                const script = document.createElement('script');
                script.setAttribute('src', `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&callback=${functionName}`);
                document.body.appendChild(script);
            }
        });

        return this.mapPromise;
    }
}